import { Box, Container, Typography, useTheme } from "@mui/material";
import JsonLd from "../components/JsonLd";
import BlogPostCard from "../components/blog/BlogPostCard";
import { BLOG_POSTS } from "../content/blog";
import { blogItemListJsonLd } from "../utils/schema";

const Blog = () => {
  const theme = useTheme();
  const jsonLd = { "@context": "https://schema.org", "@graph": [blogItemListJsonLd(BLOG_POSTS)] };
  const featured = BLOG_POSTS.find((post) => post.featured) || BLOG_POSTS[0];
  const rest = BLOG_POSTS.filter((post) => post.slug !== featured?.slug);

  return (
    <Box sx={{ bgcolor: "#f7f5fb", pb: 8 }}>
      <JsonLd data={jsonLd} id="jsonld-blog" />
      <Box
        sx={{
          color: "white",
          background: `linear-gradient(160deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 55%, #7E57C2 100%)`,
          py: { xs: 6, md: 8 },
          px: 2,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontWeight: 800,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              fontSize: "0.75rem",
              opacity: 0.95,
              mb: 1.5,
            }}
          >
            Guides
          </Typography>
          <Typography
            component="h1"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "1.9rem", md: "2.5rem" },
              lineHeight: 1.2,
              letterSpacing: "-0.02em",
              mb: 1.5,
            }}
          >
            Treasure Blog: Student Budgeting &amp; Money Habits
          </Typography>
          <Typography sx={{ opacity: 0.94, lineHeight: 1.7, maxWidth: 560, fontSize: "1.05rem" }}>
            Guides with app screenshots: pocket money, first salary, and tracking income and expenses on Android.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mt: { xs: -3, md: -4 }, px: 2 }}>
        {featured && <BlogPostCard post={featured} variant="featured" priority />}

        {rest.length > 0 && (
          <Box sx={{ mt: { xs: 4, md: 5 } }}>
            <Typography fontWeight={800} sx={{ mb: 2.5, fontSize: "1.25rem", letterSpacing: "-0.02em" }}>
              Latest guides
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr" },
                gap: 2.5,
              }}
            >
              {rest.map((post) => (
                <BlogPostCard key={post.slug} post={post} />
              ))}
            </Box>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Blog;
